<template>
    <a v-if="videoUrl"
        class="inline-flex justify-center rounded-xl border py-[calc(--spacing(2)-1px)] px-[calc(--spacing(3)-1px)] text-md transition-colors border-ink-300 text-ink-700 hover:border-primary-400 hover:text-primary-700 active:bg-ink-100"
        variant="outline" color="gray" href="#" @click.prevent="open = true"><svg viewBox="0 0 24 24"
            fill="none" aria-hidden="true" class="h-6 w-6 flex-none">
            <circle cx="12" cy="12" r="11.5" stroke="#8abeb1"></circle>
            <path
                d="M9.5 14.382V9.618a.5.5 0 0 1 .724-.447l4.764 2.382a.5.5 0 0 1 0 .894l-4.764 2.382a.5.5 0 0 1-.724-.447Z"
                fill="#017256" stroke="#017256"></path>
        </svg><span class="ml-2.5">Watch the video</span></a>

    <Dialog v-model:visible="open" modal header="Watch the video" :style="{ width: '48rem' }" @hide="pauseVideo">
        <video ref="videoEl" :src="videoUrl" controls autoplay class="w-full rounded-xl bg-black"></video>
    </Dialog>
</template>

<script setup>
import { ref } from 'vue';
import Dialog from 'primevue/dialog';

defineProps({
    videoUrl: { type: String, default: '' },
});

const open = ref(false);
const videoEl = ref(null);

const pauseVideo = () => {
    videoEl.value?.pause();
};
</script>
